import { useEffect, useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/apiClient";
import { ReleaseItem } from "@/components/ReleaseItem";

// Finestra "Novità" all'accesso: si chiude solo con "OK, ho preso visione" (registrato per l'Admin).
export function ReleaseNotesGate() {
  const [notes, setNotes] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/release-notes/pending").then(({ data }) => setNotes(data.notes)).catch(() => {}); }, []);
  if (!notes.length) return null;
  const [latest] = notes;
  const ok = async () => {
    setSaving(true);
    try { await Promise.all(notes.map((n) => api.post(`/release-notes/${n.revision}/ack`))); setNotes([]); }
    catch (e) { toast.error(apiError(e)); setSaving(false); }
  };
  return (
    <div className="fixed inset-0 z-[200] grid place-items-center bg-forest/40 p-4 backdrop-blur-sm" role="dialog" aria-modal="true"
      aria-labelledby="release-notes-title" data-testid="release-notes-modal">
      <div className="flex max-h-[90vh] w-full max-w-lg flex-col overflow-hidden rounded-2xl bg-white shadow-2xl animate-in zoom-in-95">
        <div className="bg-forest px-6 py-5 text-white">
          <div className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-white/70">
            <Sparkles className="h-4 w-4 text-sector-yellow" /> Aggiornamento n. <span data-testid="release-notes-revision">{latest.revision}</span> · {latest.date}
          </div>
          <h2 id="release-notes-title" className="mt-1 font-heading text-xl font-semibold">{latest.title}</h2>
        </div>
        <div className="flex-1 space-y-5 overflow-y-auto px-6 py-5" data-testid="release-notes-items">
          {notes.map((n, k) => (
            <div key={n.revision} data-testid={`release-notes-block-${n.revision}`}>
              {k > 0 && <div className="mb-2 border-t pt-4 text-xs font-bold uppercase tracking-wider text-muted-foreground">Aggiornamento n. {n.revision} · {n.date} — {n.title}</div>}
              <ul className="space-y-2.5">
                {n.items.map((t, i) => <ReleaseItem key={i} item={t} testid={`release-item-${n.revision}-${i}`} onTry={ok} />)}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t px-6 py-4">
          <p className="mb-3 text-center text-xs text-muted-foreground" data-testid="release-notes-hint">Se vuoi, provala ora; altrimenti continua pure la tua attività.</p>
          <button onClick={ok} disabled={saving} data-testid="release-notes-ok"
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-terracotta py-3 text-sm font-bold uppercase tracking-wide text-white transition-colors hover:bg-terracotta-hover disabled:opacity-60">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "OK, ho preso visione — continua"}
          </button>
        </div>
      </div>
    </div>
  );
}
